import FormikContextInputField from '../../../../../../components/formikFileds/FormikContextInputField';
import {toEnglishDigits} from '../../../../../../utilities/helper/toEnglishNumber';
import {formatPhoneNumber} from '../../utils/number';

interface OneGuarantorFormProps {
  fieldPrefix: 'Guarantor-0' | 'Guarantor-1';
}

const OneGuarantorForm = ({fieldPrefix}: OneGuarantorFormProps) => {
  return (
    <div className="flex flex-col gap-2 text-gray-700">
      <FormikContextInputField
        name={`${fieldPrefix}.name`}
        label="نام و نام خانوادگی ضامن"
        placeholder="نام و نام خانوادگی ضامن را وارد کنید"
        className="placeholder:text-sm"
        required
      />

      <FormikContextInputField
        name={`${fieldPrefix}.national_code`}
        label="کد ملی ضامن"
        placeholder="کد ملی ضامن را وارد کنید"
        onChangeFormatter={toEnglishDigits}
        type="number"
        inputMode="numeric"
        className="placeholder:text-sm"
        required
      />

      <FormikContextInputField
        name={`${fieldPrefix}.cellphone_number`}
        label="شماره موبایل ضامن"
        placeholder=" شماره موبایل ضامن را وارد کنید. مثال: 09123456789"
        required
        type="number"
        inputMode="numeric"
        className="placeholder:text-sm"
        onChangeFormatter={formatPhoneNumber}
        maxLength={11}
      />
    </div>
  );
};

export default OneGuarantorForm;
